import { useCallback, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from '@shared/hooks';
import { useCashFlowTransactionsTableColumns } from '@modules/cash-flow';
import { CashFlowTransactionsTableContext } from '../../context';

export const useCashFlowTransactionsTable = () => {
  const columns = useCashFlowTransactionsTableColumns();
  const { mergeState, handleFetch } = useContext(CashFlowTransactionsTableContext);
  const { searchParams, remove } = useSearchParams<{ reFetchCashFlowTransactionsTable?: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const getRowProps = useCallback(
    (id: any) => ({
      onDoubleClick: () => navigate(`/cash-flow/transactions/${id}`),
    }),
    [navigate],
  );

  useEffect(() => {
    if (location.state?.cashFlowTransactionsTable?.mergeState) {
      mergeState(location.state.cashFlowTransactionsTable.mergeState);
    }
  }, [location.state?.cashFlowTransactionsTable?.mergeState, mergeState]);

  useEffect(() => {
    if (searchParams.reFetchCashFlowTransactionsTable) {
      remove.current('reFetchCashFlowTransactionsTable');
      handleFetch();
    }
  }, [handleFetch, remove, searchParams.reFetchCashFlowTransactionsTable]);

  return { columns, getRowProps };
};
